import { render, staticRenderFns } from "./crearReporteGenerados.vue?vue&type=template&id=228f100b"
import script from "./crearReporteGenerados.vue?vue&type=script&lang=js"
export * from "./crearReporteGenerados.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports